<template>
  <div id="app">
    <img src="@/assets/top_right_bg.png" alt="" class="top-right-bg">
    <HeaderComponent class="container" />
    <!-- <nav>
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </nav> -->
    <router-view />
    <GetInTouch class="container" />
    <FooterComponent class="" />

  </div>
</template>


<script>
// @ is an alias to /src
import HeaderComponent from '@/components/common/HeaderComponent.vue'
import GetInTouch from '@/components/common/GetInTouch.vue'
import FooterComponent from '@/components/common/FooterComponent.vue'
export default {
  name: 'HomeView',
  components: {
    HeaderComponent,
    GetInTouch,
    FooterComponent
  }
}
</script>

<style>
/* 
matt blue #102c46
matt green #056251
light green #1eb53b
matt gold #c69064 #e1c493 
*/
#app {
  font-family: Helvetica, Arial, sans-serif;
}

a {
  color: #1eb53b;
}

a:hover {
  color: #102c46;
}

.c-link {
  color: #1eb53b !important;
}

.c-link:hover {
  color: #102c46 !important;
}

html {
  scroll-behavior: smooth;
}

.top-right-bg {
  position: absolute;
  right: 0;
  z-index: -1;
}

/* Reset the default focus outline */
:focus-visible {
  outline: none;
  box-shadow: none;
  /* Light green focus */
}

/* Add additional styles for buttons */
button:focus-visible {
  background-color: none;
  /* Matt green background */
  color: #fff;
}

/* Add styles for links */
a:focus-visible {
  text-decoration: underline;
  color: none;
  border-radius: 4px;
  /* Light green */
}
</style>